export var ConfigIntegrationKind;
(function (ConfigIntegrationKind) {
    ConfigIntegrationKind["TypicalSite"] = "typical";
    ConfigIntegrationKind["WordPress"] = "wordpress";
    ConfigIntegrationKind["Shopify"] = "shopify";
    ConfigIntegrationKind["Blogger"] = "blogger";
    ConfigIntegrationKind["Magento"] = "magento";
    ConfigIntegrationKind["Drupal"] = "drupal";
    ConfigIntegrationKind["SquareSpace"] = "squarespace";
    ConfigIntegrationKind["Joomla"] = "joomla";
    ConfigIntegrationKind["Weebly"] = "weebly";
    ConfigIntegrationKind["Wix"] = "wix";
    ConfigIntegrationKind["Custom"] = "custom";
})(ConfigIntegrationKind || (ConfigIntegrationKind = {}));
export var NotificationClickMatchBehavior;
(function (NotificationClickMatchBehavior) {
    NotificationClickMatchBehavior["Exact"] = "exact";
    NotificationClickMatchBehavior["Origin"] = "origin";
})(NotificationClickMatchBehavior || (NotificationClickMatchBehavior = {}));
export var NotificationClickActionBehavior;
(function (NotificationClickActionBehavior) {
    NotificationClickActionBehavior["Navigate"] = "navigate";
    NotificationClickActionBehavior["Focus"] = "focus";
})(NotificationClickActionBehavior || (NotificationClickActionBehavior = {}));
//# sourceMappingURL=AppConfig.js.map